import { _ as o, f as a, t as e, a as i } from "./export-cdcbfb2b.js";
var n = o, u = a, v = e, O = i, f = u(function() {
  return (/* @__PURE__ */ new Date(NaN)).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function() {
    return 1;
  } }) !== 1;
});
n({ target: "Date", proto: !0, arity: 1, forced: f }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function(s) {
    var t = v(this), r = O(t, "number");
    return typeof r == "number" && !isFinite(r) ? null : t.toISOString();
  }
});
